import styled from 'styled-components'
import { media } from '../../../../layouts/utils'

export const Container = styled.div`
  display: flex;
  gap: 20px;
  height: 362px;
  padding: 0 131px 0 131px;
  justify-content: space-between;
  align-items: center;
	background: linear-gradient(116deg, #230C87 22.96%, #CC0B35 112.26%);

  @media(max-width: 1050px) {
    padding: 0 50px 0 50px;
  }

  @media(max-width: 767px) {
    gap: 16px;
    height: auto;
    padding: 24px 50px 32px 50px;

    & > img {
      display: none;
    }
  }
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`

export const Background = styled.img`
  background-image: cover;
  width: 100%;
  height: 450px;
  object-fit: cover;
  ${media.phone`
    display: flex;
    height: 100%;
    top: 0;
  `}
`;

export const BackgroundImage = styled.img``

export const TextIntro = styled.span`
  max-width: 290px;

  font-family: 'Work Sans';
  font-weight: 400;
  color: ${(props) => props.cor};
  font-size: 20px;
  line-height: 24px;
  text-align: left;

  @media(max-width: 767px) {
    padding: 0;
    margin: 0;
    max-width: 280px;
    font-weight: 400;
    color: white;
    font-size: 18px;
    line-height: 21px;
  }
`;

export const Title = styled.h1`
  margin: 0;

  font-family: 'Platform Web';
  line-height: 55px;
  color: ${(props) => props.cor};
  font-weight: 500;
  font-size: 48px;
  max-width: 500px;
  text-align: left;

  @media(max-width: 1030px) {
    font-size: 40px;
    line-height: 40px;
  }

  @media(max-width: 767px) {
    font-weight: 500;
    font-size: 28px;
    line-height: 33px;
  }
`;

export const Button = styled.button`
  display: flex;
  padding: 17px 32px;
  justify-content: center;
  align-items: center;

  font-family: "Work Sans";
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  border: 1px solid transparent;
  color: ${({ color }) => color};
  border-radius: 100px;
  background: ${({ background }) => background};
  transition: all 0.5s;

  &:hover {
    border-color: #fff;
    color: #fff;
    background: transparent;
  }
`